import male2169475 from '/assets/images/male_2169475.png'
import male2169486 from '/assets/images/male_2169486.png'
import male2170310 from '/assets/images/male_2170310.png'
import male2171947 from '/assets/images/male_2171947.png'
import male2171958 from '/assets/images/male_2171958.png'
import maleFeature2169475 from '/assets/images/male_feature_2169475.png'
import maleFeature2169486 from '/assets/images/male_feature_2169486.png'
import maleFeature2170310 from '/assets/images/male_feature_2170310.png'
import maleFeature2171947 from '/assets/images/male_feature_2171947.png'
import maleFeature2171958 from '/assets/images/male_feature_2171958.png'
import female2169475 from '/assets/images/female_2169475.png'
import female2169486 from '/assets/images/female_2169486.png'
import female2170310 from '/assets/images/female_2170310.png'
import female2171947 from '/assets/images/female_2171947.png'
import female2171958 from '/assets/images/female_2171958.png'
import femaleFeature2169475 from '/assets/images/female_feature_2169475.png'
import femaleFeature2169486 from '/assets/images/female_feature_2169486.png'
import femaleFeature2170310 from '/assets/images/female_feature_2170310.png'
import femaleFeature2171947 from '/assets/images/female_feature_2171947.png'
import femaleFeature2171958 from '/assets/images/female_feature_2171958.png'
export const EYECATCHES_BY_GENDER = {
  // require_method with dynamic variable will make code more complex. (https://requirejs.org/docs/errors.html#notloaded)
  2169475: { male: male2169475.png, female: female2169475.png },
  2169486: { male: male2169486.png, female: female2169486.png },
  2170310: { male: male2170310.png, female: female2170310.png },
  2171947: { male: male2171947.png, female: female2171947.png },
  2171958: { male: male2171958.png, female: female2171958.png }
}

export const FEATURE_EYECATCHES_BY_GENDER = {
  2169475: {
    title: '今回のイベントは<strong style="font-size:20px;">「朝活」</strong>イベント！',
    content: {
      male: '<strong style="color:Magenta;font-size:20px;">オススメポイント</strong>\n・生活リズムの合う人に出会える♪\n・チケット価格が安いからお得♪\n・終わる時間が早いから二次会に誘いやすい♪\n\n<strong style="color:Peru;">朝ごはんが美味しいと、なんだか1日が楽しくなる♡</strong>',
      female:
        '<strong style="color:Magenta;font-size:20px;">オススメポイント</strong>\n・生活リズムが合う人と出会える♪\n・自立した男性が多いから頼りになる♪\n・チケット価格が安いから気軽に参加できる♪\n\n<strong style="color:Peru;">朝ごはんが美味しいと、なんだか1日が楽しくなる♡</strong>'
    },
    image: {
      male: maleFeature2169475.png,
      female: femaleFeature2169475.png
    }
  },
  2169486: {
    title: '今回のイベントは<strong style="font-size:20px;">「ランチ」</strong>イベント！',
    content: {
      male: '<strong style="color:Magenta;font-size:20px;">オススメポイント</strong>\n・ランチを食べながら出会える♪\n・着席形式だから出会いに集中できる♪\n・チケット価格が安いからお得♪\n\n<strong style="color:red;">同世代と出会える</strong>ように年齢設定をしています♪\n「年上の人とお話したいけど、年齢が離れ過ぎはイヤ！」\n「年下の人と話をすると気が楽だけど、年齢が離れすぎると話題が …」\nという心配は必要ナシ！！\n\n<strong style="color:Peru;">お昼から行動すると\nなにかいいことあるかも？？♡</strong>',
      female:
        '<strong style="color:Magenta;font-size:20px;">オススメポイント</strong>\n・ランチを食べながら出会える♪\n・着席形式だからヒールでも安心♪\n・チケット価格が安いから気軽に参加できる♪\n\n<strong style="color:red;">同世代と出会える</strong>ように年齢設定をしています♪\n「年上の人とお話したいけど、年齢が離れ過ぎはイヤ！」\n「年下の人と話をすると気が楽だけど、年齢が離れすぎると話題が …」\nという心配は必要ナシ！！\n\n<strong style="color:Peru;">お昼から行動すると\nなにかいいことあるかも？？♡</strong>'
    },
    image: {
      male: maleFeature2169486.png,
      female: femaleFeature2169486.png
    }
  },
  2170310: {
    title: '今回のイベントは<strong style="font-size:20px;">「20代限定」</strong>イベント！',
    content: {
      male: '<strong style="color:Magenta;font-size:20px;">甘え上手なカノジョ</strong>\n<strong>可愛らしい服装･容姿♪\n人懐っこくて、純粋な人♪\n過去の開催では20代前半がほとんど！</strong>\n\n<span style="color:RoyalBlue;">・なんでも受け止めてくれる、心が広い人\n・余裕と落ち着きがある人\n・多少のことでは怒らず、聞き上手な人</span>\nそんな男性を大募集しています♪',
      female:
        '<strong style="color:RoyalBlue;font-size:20px;">包容力のあるカレシ</strong>\n・なんでも受け止めてくれる、心が広い人\n・余裕と落ち着きがある人\n・多少のことでは怒らず、聞き上手な人\n\n<strong style="color:Magenta;">たくさん甘えられるカレシ見つけませんか？♡</strong>'
    },
    image: {
      male: maleFeature2170310.png,
      female: femaleFeature2170310.png
    }
  },
  2171947: {
    title:
      '今回のイベントは<strong style="font-size:20px;">「同世代」</strong>イベント！\n\n<strong style="color:red;font-size:20px;">参加条件は24～29歳の男女！</strong>\n\n<strong style="color:Magenta;font-size:20px;">最大でも5歳差</strong>だから、気があう！話が合う！\nとっても盛り上がる！と大好評企画です♪',
    content: {
      male: '<strong style="color:Magenta;font-size:20px;">彼を支えてあげたい女性</strong>\n<strong>彼のために尽くすのが好き\n疲れた時に話を聞いてくれる</strong>\nそんな女性が参加予定♡\n\n<strong style="color:RoyalBlue;">誠実・社交的・リード上手</strong>\nに当てはまる男性お待ちしております！！',
      female:
        '<strong style="color:RoyalBlue;font-size:20px;">恋人思いの一途な男性</strong>\n誠実・社交的・リード上手な\n男性が多いのも嬉しいポイント♪\n\n<strong style="color:Magenta;">頼れるカレを支えてあげたいッッ</strong>\nという女性を大募集しています♪'
    },
    image: {
      male: maleFeature2171947.png,
      female: femaleFeature2171947.png
    }
  },
  2171958: {
    title: '今回のイベントは<strong style="font-size:20px;">「安定男子」</strong>イベント！',
    content: {
      male: '<strong style="color:Magenta;font-size:20px;">色白な可愛らしいカノジョ</strong>\n<strong>思わず見とれてしまう色白な肌♡\n笑顔が可愛らしい女性が多数♪♪</strong>\n\n<strong style="color:RoyalBlue;font-size:20px;">男性の参加条件</strong>\n大手企業(総従業員数300人以上)または上場企業\n公務員、医師、弁護士としてお勤めの方',
      female:
        '<strong style="color:red;font-size:20px;">男性の参加条件</strong>\n大手企業(総従業員数300人以上)または上場企業\n公務員、医師、弁護士としてお勤めの方\n\n▲熱心に仕事に取り組む姿にドキッ♡\n▲スーツ姿がかっこよくてドキッ♡\nそんな<strong style="color:RoyalBlue;font-size:20px;">爽やかな安定男子</strong>と出会いませんか？'
    },
    image: {
      male: maleFeature2171958.png,
      female: femaleFeature2171958.png
    }
  }
}

export const getCustomEyecatch = (eventId, profile, gender) => {
  if (EYECATCHES_BY_GENDER[eventId] && profile && profile.id % 10 < 5) return EYECATCHES_BY_GENDER[eventId][gender]
  return null
}

export const getFeatureEyecatch = eventId => {
  return FEATURE_EYECATCHES_BY_GENDER[eventId]
}

export const getWebpImageSrc = imageUrl => {
  const regex = /^(http(s)?:\/\/.*)\.\w*$/
  return imageUrl?.replace(regex, '$1.webp') || ''
}
